/** Flags de impressão persistidas em `prescription.print_settings`. */

export function getHideIssueDateOnPrint(printSettings: unknown): boolean {
  return Boolean((printSettings as { hide_issue_date_on_print?: unknown } | null)?.hide_issue_date_on_print);
}

export function setHideIssueDateOnPrint(
  existing: Record<string, unknown> | null | undefined,
  hide: boolean,
): Record<string, unknown> {
  const next = { ...(existing || {}) };
  if (hide) next.hide_issue_date_on_print = true;
  else delete next.hide_issue_date_on_print;
  return next;
}

export function mergePrescriptionPrintSettings(
  existing: Record<string, unknown> | null | undefined,
  patch: Record<string, unknown>,
): Record<string, unknown> {
  return { ...(existing || {}), ...patch };
}
